import { JSX } from 'react';

type LocalSettingsProps = { showTitle?: boolean };

export default function LocalSettings(_: LocalSettingsProps): JSX.Element | null {
	return null;
}
